import buildQuery, { Filter } from 'odata-query';

export interface ODataResponse<T> {
  '@odata.context': string | undefined;
  '@odata.count': number | undefined;
  value: T | undefined;
}

export function odataResponseFactory<T>(obj: Partial<ODataResponse<T>>): ODataResponse<T> {
  return {
    '@odata.context': obj['@odata.context'],
    '@odata.count': obj['@odata.count'],
    value: obj.value
  };
}

export interface ODataParams {
  filter: Filter | undefined;
  select: string[] | undefined;
  top: number;
  skip: number;
  expand: string | undefined;
  orderBy: string | undefined;

  count: true; // we always want to get the count

  toQuery(): string;
}

export function odataParamsFactory(obj: Partial<ODataParams>): ODataParams {
  return {
    filter: obj?.filter,
    select: obj?.select,
    top: obj?.top || 50,
    skip: obj?.skip || 0,
    expand: obj?.expand,
    orderBy: obj?.orderBy,
    count: true,
    toQuery: () => {
      return buildQuery({
        select: !obj?.select ? undefined : obj.select?.join(','),
        filter: obj.filter,
        top: obj.top,
        skip: obj.skip,
        count: true,
        expand: obj.expand,
        orderBy: obj.orderBy
      });
    }
  };
}
